import { ref, nextTick } from 'vue';

/**
 * 处理 Surf 组件滚动相关的 hook
 * @param {Boolean} mobile - 是否为移动端
 * @param {Function} onTabChange - 标签页切换时的回调函数，接收 value 参数
 * @returns {Object} { offsetTop, calcOffsetTop, handleTabChange }
 */
export function useSurfScroll(mobile = false, onTabChange = null) {
	const offsetTop = ref(0);

	/**
	 * 计算偏移量
	 */
	const calcOffsetTop = () => {
		nextTick(() => {
			const wrap = document.querySelector('.surf-detail-header-affix');
			const nav = document.querySelector('.nav-content');
			if (wrap) {
				const targetRect = wrap.getBoundingClientRect();
				offsetTop.value = targetRect.height;
			}
			if (nav) {
				offsetTop.value += nav.getBoundingClientRect().height;
			}
		});
	};

	/**
	 * 处理标签页切换，并滚动到对应位置
	 * 支持两种调用方式：
	 * 1. SurfSecondTab 格式: ({ index, data, value })
	 * 2. SurfTabs 格式: (index, item)
	 * @param {Object|Number} arg1 - 对象参数或索引
	 * @param {Object} arg2 - item 对象（SurfTabs 格式时使用）
	 */
	const handleTabChange = (arg1, arg2) => {
		let targetId, tabValue;
		
		// 判断调用方式：如果是对象且有 value 属性，则是 SurfSecondTab 格式
		if (arg1 && typeof arg1 === 'object' && 'value' in arg1) {
			// SurfSecondTab 格式: { index, data, value }
			targetId = arg1.value;
			tabValue = arg1.value;
		} else if (arg2 && typeof arg2 === 'object') {
			// SurfTabs 格式: (index, item)
			targetId = arg2.id || arg2.value;
			tabValue = arg2.value;
		}

		// 调用外部回调更新 activeTab
		if (onTabChange && typeof onTabChange === 'function') {
			onTabChange(tabValue);
		}

		// 滚动到对应的 surf-content-section
		nextTick(() => {
			if (targetId) {
				const targetElement = document.getElementById(targetId);

				if (targetElement) {
					// 动态计算偏移量：扣除 SurfSecondTab 和父组件 SurfTabs 的高度
					let yOffset = 0;

					// 获取 SurfSecondTab 的高度
					const surfSecondTab = document.querySelector('.surf-detail-header-affix');
					if (surfSecondTab) {
						yOffset -= surfSecondTab.getBoundingClientRect().height;
					}

					// 获取父组件 SurfTabs 的高度（在 full.vue 中，位于 .rs-d-surf-container 下的第一个 SurfDetailHeaderAffix 中）
					const container = document.querySelector(mobile ? '.child-container' : '.rs-d-surf-container');
					if (container) {
						const parentSurfTabs = container.querySelector('.surf-detail-header-affix');
						if (parentSurfTabs) {
							yOffset -= parentSurfTabs.getBoundingClientRect().height;
						}
					}

					if (mobile) {
						const nav = document.querySelector('#surfMobNavContainer');
						if (nav) {
							yOffset -= nav.getBoundingClientRect().height;
						}
					}
					let y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

					window.scrollTo({ top: y, behavior: 'smooth' });
				}
			}
		});
	};

	return {
		offsetTop,
		calcOffsetTop,
		handleTabChange
	};
}

